// import React, { useState } from 'react';
// import { 
//   Card, 
//   CardContent, 
//   Typography, 
//   Button, 
//   Grid, 
//   Box,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton
// } from "@mui/material";
// import {
//   EditNote,
//   GppGood,
//   Schedule,
//   Settings,
//   Security,
//   SupportAgent,
//   Close as CloseIcon
// } from "@mui/icons-material";

// interface Service {
//   title: string;
//   description: string;
//   icon: React.ReactNode;
//   details: string[];
// }

// const services: Service[] = [
//   {
//     title: "Expert Academic Writers",
//     description: "Our team consists of highly qualified professionals with expertise in various disciplines.",
//     icon: <EditNote sx={{ fontSize: 40 }} />,
//     details: [
//       "PhD-qualified writers in every field",
//       "Extensive research experience",
//       "Native English speakers",
//       "Proven track record of academic excellence",
//       "Regular quality assessments"
//     ]
//   },
//   {
//     title: "Plagiarism-Free Work",
//     description: "We ensure original content with thorough plagiarism checks.",
//     icon: <GppGood sx={{ fontSize: 40 }} />,
//     details: [
//       "Multiple plagiarism detection tools",
//       "Original research and writing",
//       "Proper citations and referencing",
//       "Free plagiarism report",
//       "100% unique content guarantee"
//     ]
//   },
//   {
//     title: "Timely Delivery",
//     description: "We adhere to strict deadlines to help you submit your dissertation on time.",
//     icon: <Schedule sx={{ fontSize: 40 }} />,
//     details: [
//       "Guaranteed on-time delivery",
//       "Progress updates",
//       "Flexible scheduling options",
//       "Rush delivery available",
//       "Time zone accommodation"
//     ]
//   },
//   {
//     title: "Customized Approach",
//     description: "Every dissertation is tailored to meet your specific requirements.",
//     icon: <Settings sx={{ fontSize: 40 }} />,
//     details: [
//       "Personalized writing style",
//       "Subject-specific methodology",
//       "Custom formatting options",
//       "Regular client consultation",
//       "Unlimited revisions"
//     ]
//   },
//   {
//     title: "Confidentiality Assured",
//     description: "Your personal and academic information remains secure with us.",
//     icon: <Security sx={{ fontSize: 40 }} />,
//     details: [
//       "Encrypted data storage",
//       "Non-disclosure agreement",
//       "Secure payment process",
//       "Anonymous service",
//       "Private communication channels"
//     ]
//   },
//   {
//     title: "24/7 Customer Support",
//     description: "We're available round-the-clock to assist you, ensuring a hassle-free experience.",
//     icon: <SupportAgent sx={{ fontSize: 40 }} />,
//     details: [
//       "24/7 live chat support",
//       "Dedicated support team",
//       "Multiple communication channels",
//       "Quick response time",
//       "Multilingual support staff"
//     ]
//   }
// ];

// const ServiceCard: React.FC<{ service: Service; onClick: () => void }> = ({ service, onClick }) => (
//   <Card sx={{ 
//     height: '100%', 
//     display: 'flex', 
//     flexDirection: 'column', 
//     alignItems: 'center', 
//     textAlign: 'center',
//     '&:hover': {
//       boxShadow: 6
//     }
//   }}>
//     <CardContent sx={{ 
//       display: 'flex', 
//       flexDirection: 'column', 
//       alignItems: 'center', 
//       gap: 2,
//       flexGrow: 1,
//       p: 3
//     }}>
//       <Box sx={{ 
//         bgcolor: '#172554', 
//         borderRadius: '50%', 
//         p: 2,
//         color: 'white'
//       }}>
//         {service.icon}
//       </Box>
//       <Typography variant="h6" component="h3" gutterBottom>
//         {service.title}
//       </Typography>
//       <Typography variant="body2" color="black" sx={{ mb: 2 }}>
//         {service.description}
//       </Typography>
//       <Button 
//         variant="contained" 
//         onClick={onClick}
//         sx={{ 
//           mt: 'auto',
//           bgcolor: '#172554',
//           '&:hover': {
//             bgcolor: '#f97316',
//           }
//         }}
//       >
//         Learn More
//       </Button>
//     </CardContent>
//   </Card>
// );

// const ServiceDialog: React.FC<{ 
//   service: Service | null; 
//   open: boolean; 
//   onClose: () => void; 
// }> = ({ service, open, onClose }) => {
//   if (!service) return null;

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         gap: 1,
//         pr: 6 
//       }}>
//         <Box sx={{ color: '#172554' }}>{service.icon}</Box>
//         {service.title}
//         <IconButton
//           onClick={onClose}
//           sx={{ position: 'absolute', right: 8, top: 8 }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>
//       <DialogContent>
//         <Typography color="text.secondary" paragraph sx={{ mt: 1 }}>
//           {service.description}
//         </Typography>
//         <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
//           Key Features:
//         </Typography>
//         <Box component="ul" sx={{ 
//           listStyle: 'none', 
//           p: 0,
//           m: 0
//         }}>
//           {service.details.map((detail, index) => (
//             <Box
//               component="li"
//               key={index}
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1,
//                 mb: 1
//               }}
//             >
//               <Box
//                 sx={{
//                   width: 6,
//                   height: 6,
//                   borderRadius: '50%',
//                   bgcolor: '#172554'
//                 }}
//               />
//               <Typography>{detail}</Typography>
//             </Box>
//           ))}
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// const EssayWritingServices: React.FC = () => {
//   const [selectedService, setSelectedService] = useState<Service | null>(null);

//   return (
//     <Box sx={{ p: 5, bgcolor: '#f3f4f6' }}>
//         <Typography 
//           variant="h5" 
//           fontWeight={600} 
//           gutterBottom 
//           textAlign={"center"}
//           color={"#172554"}
//           sx={{ fontSize: { xs: "20px", sm: "24px", md: "28px" } }}
//         >      Why{" "}
//            <span
//              style={{
//                background:
//                  "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
//                padding: "0px 5px",
//              }}
//            >
//              Choose Our Dissertation
//            </span>{" "}
//            Writing Services?
//       </Typography>
//       <Grid container spacing={3}>
//         {services.map((service, index) => (
//           <Grid item xs={12} sm={6} md={4} key={index}>
//             <ServiceCard
//               service={service}
//               onClick={() => setSelectedService(service)}
//             />
//           </Grid>
//         ))}
//       </Grid>
//       <ServiceDialog
//         service={selectedService}
//         open={Boolean(selectedService)}
//         onClose={() => setSelectedService(null)}
//       />
//     </Box>
//   );
// };

// export default EssayWritingServices;








import React, { useState } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  Grid, 
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  useTheme,
  useMediaQuery
} from "@mui/material";
import {
  EditNote,
  GppGood,
  Schedule,
  Settings,
  Security,
  SupportAgent,
  Close as CloseIcon
} from "@mui/icons-material";

interface Service {
  title: string;
  description: string;
  icon: React.ReactNode;
  details: string[];
}

const services: Service[] = [
  {
    title: "Expert Academic Writers",
    description: "Our team consists of highly qualified professionals with expertise in various disciplines.",
    icon: <EditNote sx={{ fontSize: 40 }} />,
    details: [
      "PhD-qualified writers in every field",
      "Extensive research experience",
      "Native English speakers",
      "Proven track record of academic excellence",
      "Regular quality assessments"
    ]
  },
  {
    title: "Plagiarism-Free Work",
    description: "We ensure original content with thorough plagiarism checks.",
    icon: <GppGood sx={{ fontSize: 40 }} />,
    details: [
      "Multiple plagiarism detection tools",
      "Original research and writing",
      "Proper citations and referencing",
      "Free plagiarism report",
      "100% unique content guarantee"
    ]
  },
  {
    title: "Timely Delivery",
    description: "We adhere to strict deadlines to help you submit your dissertation on time.",
    icon: <Schedule sx={{ fontSize: 40 }} />,
    details: [
      "Guaranteed on-time delivery",
      "Progress updates",
      "Flexible scheduling options",
      "Rush delivery available",
      "Time zone accommodation"
    ]
  },
  {
    title: "Customized Approach",
    description: "Every dissertation is tailored to meet your specific requirements.",
    icon: <Settings sx={{ fontSize: 40 }} />,
    details: [
      "Personalized writing style",
      "Subject-specific methodology",
      "Custom formatting options",
      "Regular client consultation",
      "Unlimited revisions"
    ]
  },
  {
    title: "Confidentiality Assured",
    description: "Your personal and academic information remains secure with us.",
    icon: <Security sx={{ fontSize: 40 }} />,
    details: [
      "Encrypted data storage",
      "Non-disclosure agreement",
      "Secure payment process",
      "Anonymous service",
      "Private communication channels"
    ]
  },
  {
    title: "24/7 Customer Support",
    description: "We're available round-the-clock to assist you, ensuring a hassle-free experience.",
    icon: <SupportAgent sx={{ fontSize: 40 }} />,
    details: [
      "24/7 live chat support",
      "Dedicated support team",
      "Multiple communication channels",
      "Quick response time",
      "Multilingual support staff"
    ]
  }
];

const ServiceCard: React.FC<{ service: Service; onClick: () => void }> = ({ service, onClick }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        textAlign: 'center',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-10px)',
          boxShadow: theme.shadows[6]
        },
        borderRadius: 3,
        p: isSmallScreen ? 1 : 0
      }}
    >
      <CardContent 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: 2,
          flexGrow: 1,
          p: 3,
          textAlign: 'center',
          width: '100%'
        }}
      >
        <Box 
          sx={{ 
            bgcolor: '#172554', 
            borderRadius: '50%', 
            p: 2,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1
          }}
        >
          {service.icon}
        </Box>
        <Typography 
          variant="h6" 
          component="h3" 
          sx={{ 
            fontWeight: 700, 
            color: '#172554',
            mb: 1,
            textTransform: 'uppercase',
            fontSize: "17px",
          }}
        >
          {service.title}
        </Typography>
        <Typography 
          variant="body2" 
          color="black" 
          sx={{ 
            mb: 2, 
            textAlign: 'center',
            lineHeight: 1.6,
            fontSize: "16px"
          }}
        >
          {service.description}
        </Typography>
        <Button 
          variant="contained" 
          onClick={onClick}
          sx={{ 
            mt: 'auto',
            bgcolor: '#172554',
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            '&:hover': {
              bgcolor: '#f97316',
              transform: 'scale(1.05)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          Learn More
        </Button>
      </CardContent>
    </Card>
  );
};

const ServiceDialog: React.FC<{ 
  service: Service | null; 
  open: boolean; 
  onClose: () => void; 
}> = ({ service, open, onClose }) => {
  if (!service) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          pr: 6,
          color: '#172554',
          fontWeight: 700
        }}
      >
        <Box sx={{ color: '#172554', display: 'flex', alignItems: 'center' }}>
          {service.icon}
        </Box>
        {service.title}
        <IconButton
          onClick={onClose}
          sx={{ 
            position: 'absolute', 
            right: 8, 
            top: 8,
            color: '#172554'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'justify' }}>
        <Typography 
          color="black" 
          paragraph 
          sx={{ 
            mt: 1, 
            lineHeight: 1.7,
            textAlign: 'justify'
          }}
        >
          {service.description}
        </Typography>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            mt: 2, 
            color: 'black',
            fontWeight: 700
          }}
        >
          
        </Typography>
        <Box 
          component="ul" 
          sx={{ 
            listStyle: 'none', 
            p: 0,
            m: 0
          }}
        >
          {service.details.map((detail, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mb: 1.5,
                pl: 1
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: '#172554'
                }}
              />
              <Typography 
                sx={{ 
                  textAlign: 'left',
                  lineHeight: 1.6
                }}
              >
                {detail}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const WhyChooseOurDessertation: React.FC = () => {
  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box 
      sx={{ 
        p: isSmallScreen ? 2 : 5, 
        bgcolor: '#f3f4f6',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
<Typography 
          variant="h5" 
          fontWeight={600} 
          gutterBottom 
          textAlign={"center"}
          color={"#172554"}
          marginBottom={"8px"}
          sx={{ fontSize: { xs: "20px", sm: "24px", md: "26px" } }}
        >      Why{" "}
           <span
             style={{
               background:
                 "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
               padding: "0px 5px",
             }}
           >
             Choose Our Dissertation
           </span>{" "}
           Writing Services?
      </Typography>
      <Grid 
        container 
        spacing={4} 
        justifyContent="center"
        sx={{ 
          maxWidth: 1200,
          width: '100%'
        }}
      >
        {services.map((service, index) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            key={index}
            sx={{ display: 'flex' }}
          >
            <ServiceCard
              service={service}
              onClick={() => setSelectedService(service)}
            />
          </Grid>
        ))}
      </Grid>
      <ServiceDialog
        service={selectedService}
        open={Boolean(selectedService)}
        onClose={() => setSelectedService(null)}
      />
    </Box>
  );
};

export default WhyChooseOurDessertation;